/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useMutation
} from '@tanstack/react-query'
import type {
  UseMutationOptions,
  MutationFunction
} from '@tanstack/react-query'
import type {
  AccountTransfer,
  PostAccountsTransfersBody
} from './schema'



/**
 * Real-time off-chain funds transfers between two accounts on UTGL Network.
The source account available balance must be able to cover the transfer amount.

This endpoint is used for any internal transfer. For asset backed credit cards, this function is used for top-up an asset backed account.
 * @summary Create a Transfer
 */
export const postAccountsTransfers = (
    postAccountsTransfersBody: PostAccountsTransfersBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AccountTransfer>> => {
    return axios.post(
      `/accounts/transfers`,
      postAccountsTransfersBody,options
    );
  }



    export type PostAccountsTransfersMutationResult = NonNullable<Awaited<ReturnType<typeof postAccountsTransfers>>>
    export type PostAccountsTransfersMutationBody = PostAccountsTransfersBody
    export type PostAccountsTransfersMutationError = AxiosError<unknown>

    export const usePostAccountsTransfers = <TError = AxiosError<unknown>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAccountsTransfers>>, TError,{data: PostAccountsTransfersBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAccountsTransfers>>, {data: PostAccountsTransfersBody}> = (props) => {
          const {data} = props ?? {};

          return  postAccountsTransfers(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postAccountsTransfers>>, TError, {data: PostAccountsTransfersBody}, TContext>(mutationFn, mutationOptions)
    }
    